import { useState, useEffect, useCallback } from 'react';
import { searchAll } from '../../../services/api';
import { useAuth } from '../../../contexts/AuthContext';

export const useGlobalSearch = (searchTerm, debounceMs = 300) => {
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // eslint-disable-next-line no-unused-vars -- user reserved for future scope logic
  const { user } = useAuth();

  // Determine scope based on user context
  const getScope = useCallback(() => {
    // For now, use 'shared' scope to search across all accessible content
    // This will include user's own items plus shared items they have access to
    return 'shared';
  }, []);

  useEffect(() => {
    // Clear results if search term is empty
    if (!searchTerm || !searchTerm.trim()) {
      setResults(null);
      setError(null);
      return;
    }

    // Debounce the search
    const timeoutId = setTimeout(async () => {
      setLoading(true);
      setError(null);

      try {
        const scope = getScope();
        const searchResults = await searchAll(searchTerm.trim(), scope);
        setResults(searchResults);
      } catch (err) {
        console.error('Search error:', err);
        setError(err.message || 'Failed to search');
        setResults(null);
      } finally {
        setLoading(false);
      }
    }, debounceMs);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, debounceMs, getScope]);

  return { results, loading, error };
};

